import { useCurrentAccountId } from "@zapier/identity";
import { useCallback } from "react";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type AgentDeleteModalAction = "confirm" | "cancel";

export function useEmitAgentDeleteModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: AgentDeleteModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.AgentDeleteModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
